import React from 'react';
import { Box, Stack, Typography, Button, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export default function BulkActionBar({ mode, selectedCount, onBulkAction }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (selectedCount === 0) {
    // ยังไม่ได้เลือกอะไร — คงพื้นที่ไว้เท่าเดิมบน desktop (กันหัวตารางกระโดด), บนมือถือยุบทิ้งเลย
    return isMobile ? null : (
      <Box
        sx={{
          flexShrink: 0,
          borderBottom: '1px solid',
          borderColor: 'divider',
          minHeight: 44,
        }}
      />
    );
  }

  return (
    <Box
      sx={{
        flexShrink: 0,
        borderBottom: '1px solid',
        borderColor: 'divider',
        px: 1.5,
        py: 1,
        bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        justifyContent: isMobile ? 'flex-start' : 'flex-end',
        alignItems: isMobile ? 'stretch' : 'center',
        gap: 1,
      }}
    >
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ mr: isMobile ? 0 : 0.5, alignSelf: isMobile ? 'flex-start' : 'center' }}
      >
        เลือก {selectedCount} รายการ
      </Typography>
      <Stack
        direction="row"
        spacing={1}
        sx={{ width: isMobile ? '100%' : 'auto' }}
      >
        <Button
          fullWidth={isMobile}
          size="small"
          color="success"
          variant="contained"
          onClick={() => onBulkAction(mode.positiveAction.code)}
        >
          {mode.positiveAction.label}
        </Button>
        <Button
          fullWidth={isMobile}
          size="small"
          color="error"
          variant="outlined"
          onClick={() => onBulkAction(mode.negativeAction.code)}
        >
          {mode.negativeAction.label}
        </Button>
        <Button
          fullWidth={isMobile}
          size="small"
          color="warning"
          variant="outlined"
          onClick={() => onBulkAction('HOLD')}
        >
          รอก่อน
        </Button>
      </Stack>
    </Box>
  );
}
